<template>
  <div class="main">
    <div class="content">
      <!-- <div class="msg" v-if="stepType != 'tourist'">
        <i class="el-icon-success"></i
        >账号注册成功，您可使用创建时的手机号登录。下方完善机构信息完成机构注册吧
      </div> -->
      <el-form
        :inline="false"
        ref="rulesForm"
        :rules="rules"
        :model="query"
        label-width="125px"
      >
        <el-form-item label="机构名称" style="margin-top: 20px;" prop="orgName">
          <el-input
            v-model="query.orgName"
            placeholder="请输入机构名称"
            style="width: 350px"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="机构信用代码"
          style="margin-top: 20px"
          prop="orgSocialCreditCode"
        >
          <el-input
            v-model="query.orgSocialCreditCode"
            placeholder="请输入机构信用代码"
            style="width: 350px"
          ></el-input>
        </el-form-item>
        <el-form-item style="margin: 20px 0 0 10%;">
          <el-button
            style="width: 120px"
            type="primary"
            size=""
            autofocus
            :disabled="!checked"
            @click="Submit()"
            >下一步</el-button
          >
          <el-button
            style="margin-left: 20px; width: 120px"
            size=""
            @click="cancel()"
            >取消</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { validateIdcard } from "@/utils/validate.js";
import {
  handleRegister,
  handleGetCorpStatus,
  handleGetPersonStatus,
} from "@/api/register/index.js";
export default {
  props: {
    stepType: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      checked: true,
      query: {
        orgName: "", 
        orgSocialCreditCode: "",
      }, 
      // 宁德时代新能源科技股份有限公司  91350900587527783P
      // 黄石市芭瑞艺术培训学校有限公司  91420200MA492XG3XW
      rules: {
        orgName: [
          { required: true, message: "请输入机构名称", trigger: "blur" },
        ],
        orgSocialCreditCode: [
          { required: true, message: "请输入机构信用代码", trigger: "blur" },
          { validator: validateIdcard, trigger: "blur" },
        ],
      },
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {},
  methods: {
    async Submit() {
      this.getCorpStatus();
      this.$refs["rulesForm"].validate(async (valid) => {
        if (valid) {
          let params = {
            registerKey: sessionStorage.getItem("registerKey") || "", //发送验证码后返回的key
            orgName: this.query.orgName, //机构名称
            orgSocialCreditCode: this.query.orgSocialCreditCode, //组织统一社会信用代码
          };
          console.log("创建机构参数---", params);
          const { result, data, desc } = await handleRegister(params);
          console.log("创建机构成功---", data);
          if (result === "000000" && data) {
            sessionStorage.usessionId = data.usessionId;
            this.$emit("changeStep", 3);
            this.$message({
              type: "success",
              message: "注册成功",
            });
          } else {
            this.$message({
              type: "error",
              message: desc,
            });
          }
        } else {
          this.$message({
            type: "error",
            message: "请输入必填项!",
          });
        }
      });
    },
    //查询机构状态
    async getCorpStatus() {
      let params = {
        corpName: this.query.orgName, //机构名称
        certificateNo: this.query.orgSocialCreditCode, //组织统一社会信用代码
      };
      console.log("查询机构状态参数", params);
      sessionStorage.orgName = this.query.orgName;
      const { retCode, data, retDesc } = await handleGetCorpStatus(params);
      console.log("查询机构状态---", data);
      if (retCode === "000000" && data) {
        sessionStorage.mechanismInfo = JSON.stringify(data);
      } else {
        console.error(retDesc);
      }
    },
    cancel() {
      this.$emit("changeStep", 1);
    },
  },
};
</script>

<style lang="less" scoped>
.main {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 4%;
  .content {
    width: 650px;
    .msg {
      margin: 0 auto;
      width: 550px;
      height: 40px;
      margin-bottom: 35px;
      line-height: 40px;
      font-size: 14px;
      font-family: PingFang SC;
      background: #dbffe0;
      border: 1px solid #30c443;
    }
    .el-form {
      width: 550px;
      margin: 0 auto;
    }
  }
}

::v-deep .el-form .el-input__inner {
  // width: 450px;
  height: 40px;
  border-radius: 3px;
  background: #fff;
  border: 1px solid #ddd;
}
.el-icon-success {
  margin: 0 10px;
  // background: #30C443;
  color: #30c443;
}
</style>
